// extracted by mini-css-extract-plugin
export default {"custom-popover":"PopOver_custom-popover__auMT3","custom-popover-title-only":"PopOver_custom-popover-title-only__vmJl5","btn-close":"PopOver_btn-close__VFE3q"};